export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref6805.9d9d04cd.jpg";